import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import { ImportResults } from "@/components/imports/ImportResults";
import { basicSummary } from "@/components/imports/importOutcomes";

export default function ImportDetail() {
    const { id } = useParams();
    const [batch, setBatch] = useState(null);
    const [err, setErr] = useState(null);
    useEffect(() => { api.get(`/imports/${id}`).then((r) => setBatch(r.data)).catch((e) => setErr(formatApiError(e))); }, [id]);
    return (
        <div className="space-y-6" data-testid="import-detail-page">
            <Link to="/imports" className="text-sm text-muted-foreground inline-flex items-center gap-1" data-testid="back-to-imports"><ArrowLeft className="h-4 w-4" /> Import History</Link>
            {err && <div className="text-sm text-red-700">{err}</div>}
            {batch && (
                <div>
                    <h1 className="text-2xl font-display font-semibold tracking-tight" data-testid="import-detail-filename">{batch.filename}</h1>
                    <p className="text-sm text-muted-foreground mt-1">
                        {batch.total_rows} rows · by {batch.uploaded_by_name || "—"} · {new Date(batch.created_at).toLocaleString()}
                    </p>
                    <p className="text-sm text-gray-700 mt-1" data-testid="import-basic-summary">
                        {["cancelled", "expired"].includes(batch.status) ? `${batch.status === "cancelled" ? "Cancelled" : "Expired"} before import: rows deleted, nothing imported.` : <>
                        {basicSummary({ imported: batch.imported_count, duplicates: batch.duplicate_count, invalidPhones: batch.invalid_phone_count, invalid: batch.invalid_count, failed: batch.failed_count })}</>}
                    </p>
                </div>
            )}
            <div className="bg-white border border-border rounded-xl shadow-sm p-5"><ImportResults batchId={id} /></div>
        </div>
    );
}
